import request from '@/utils/request'
import URL from '@/api/urlTranslator'
import { getAirExportJobsByLclMasterJob } from '@/api/AirExport/airExportJob'

// 获取铁出
export function getReJobDetail(uuid) {
  return request({
    url: URL.booking.railwayExport.reDetail, // todo need replace ae url of api
    method: 'get',
    params: { uuid }
  })
}

// 加载海出Job的关联实体信息
export function loadRailwayExportJobRelated(data) {
  return request({
    url: URL.booking.railwayExport.loadRailwayExportJobRelated,
    method: 'post',
    data: data
  })
}

// 投保
export function toInsure(data) {
  return request({
    url: URL.booking.railwayExport.toInsure,
    method: 'post',
    data
  })
}

// 高级查询
export function advancedQuery(data) {
  return request({
    url: URL.railwayExport.advancedQuery,
    method: 'post',
    data
  })
}

// 保存铁路出口订舱信息
export function saveRailwayExport(data, fullError, forbidAlert) {
  return request({
    url: URL.booking.railwayExport.saveRailwayExport,
    method: 'post',
    fullError,
    forbidAlert,
    data
  })
}

// 检查字段值是否重复
export function checkJobFiledExist(data) {
  return request({
    url: URL.booking.railwayExport.checkJobFiledExist,
    method: 'post',
    data
  })
}

// 批量复制小票，组装数据返回给前台
export function batchCloneLcLJob(params) {
  return request({
    url: URL.booking.railwayExport.batchCloneLcLJob,
    method: 'get',
    params
  })
}

export function saveCopyJob(data) {
  return request({
    url: URL.railwayExport.saveCopyJob,
    method: 'post',
    data
  })
}

export function isContractExpiredForbidCreateJob(cmpIdx) {
  return request({
    url: URL.booking.isContractExpiredForbidCreateJob,
    method: 'get',
    params: { cmpIdx }
  })
}

export function queryJobNoRule(type) {
  return request({
    url: URL.booking.queryJobNoRule,
    method: 'get',
    params: { type }
  })
}

export function doCopyJob(data) {
  return request({
    url: URL.railwayExport.doCopyJob,
    method: 'post',
    data
  })
}

export function splitMaster(data) {
  return request({
    url: URL.railwayExport.splitMaster,
    method: 'post',
    data
  })
}

// 根据job拼箱主票和查询条件查询 隐含条件：未拼票的job..... job:RailwayExportJob-主票的uuid
export function getRailwayExportJobsByLclMasterJob(branchId, params) {
  return request({
    url: URL.railwayExport.getRailwayExportJobsByLclMasterJob + '/' + branchId,
    method: 'get',
    params
  })
}

// 根据job拼箱主票和查询条件查询 隐含条件：未拼票的job
export function getFbaRailwayExportJobsByLclMasterJob(data) {
  return request({
    url: URL.railwayExport.getFbaRailwayExportJobsByLclMasterJob,
    method: 'post',
    data: data
  })
}
// 最近修改的单子
export function queryLastModifyBookingByDay(data) {
  return request({
    url: URL.railwayExport.queryLastModifyBookingByDay,
    method: 'post',
    data
  })
}

// 订舱预审-审核通过
export function approved(data, officeId) {
  return request({
    url: URL.railwayExport.approvedVerify,
    method: 'post',
    data,
    params: { officeId }
  })
}

// 订舱预审-审核拒绝/复核拒绝
export function preVerifyReject(jobKey, remark, preverifyState) {
  return request({
    url: URL.railwayExport.preVerifyReject,
    method: 'post',
    params: { jobKey, remark, preverifyState }
  })
}

export function batchPreVerifyReject(params) {
  return request({
    url: URL.railwayExport.batchPreVerifyReject,
    method: 'post',
    data: params
  })
}

// 查询关联业务信息
export function getRelatedJob(data) {
  return request({
    url: URL.railwayExport.getRelatedJob,
    method: 'post',
    data
  })
}

// 发送分公司保存业务
export function saveCloneJob(data) {
  return request({
    url: URL.railwayExport.saveCloneJob,
    method: 'post',
    data
  })
}
